











import { Component, Prop, Vue } from 'vue-property-decorator';
import { HalfCircleSpinner } from 'epic-spinners';

@Component({
    components: {
        HalfCircleSpinner,
    },
})
export default class IconOrLoader extends Vue {
    @Prop()
    for: string;

    @Prop({ default: false })
    loading: boolean;

    @Prop()
    color: string;

    @Prop({ default: 20 })
    size: number;

    colors: any = {
        sky: '#61aaf2',
        azure: '#0055ee',
        tiger: '#ff4411',
        coral: '#e60b0b',
        asphalt: '#081733',
        mouse: '#6c7380',
        dust: '#a8b0bf',
        snow: '#e6e6e6',
        ice: '#fafcff',
    };

    get icon() {
        return this.for;
    }

    get hexColor() {
        if (this.color && this.colors[this.color]) {
            return this.colors[this.color];
        }

        return '#ffffff';
    }
}
